import _ from 'lodash';

//  import module layouts
import modules from '../components/modules/';
import { capitalize, UCFirst } from '../../../common/utils/string';
import { resolveBoolean } from '../../../common/utils/boolean';
import Enums from '../config/enums';

/**
 * CK Taken from Items.jsx
 *
 * Utility method to calculate the collection React component class to use based on the template options for the module.
 *
 * @param  {Object} templateOpts Template options for the module.
 * @return {ReactElement} The collection React component class.
 */
function getLayoutComponent(collectionType, moduleType) {
  const layout = capitalize(collectionType);
  const type = UCFirst(moduleType);

  //  get a specific layout for the module type if it exists
  return _.get(modules[type], layout, modules[type]);
}

/**
 * Utility method to infer whether to auto-poll or not, based on sorting and filtering
 *
 * @param  {Object} filtering, current filters - user, data, type
 * @param  {Object} sorting, current sorting - sortBy, sortDir
 * @return {Boolean} true/false
 */

function allowAutoPolling(sorting, CSVersion, showMoreMode, shouldAutoPoll, experienceVersion) {
  const hasDefaultSort =
    (_.get(sorting, 'sortBy') === 'createDate' ||
      _.get(sorting, 'sortBy') === 'publishDate' ||
      _.get(sorting, 'sortBy') === 'custom' ||
      _.get(sorting, 'sortBy') === 'dateCreated') && // entries has "dateCreated"
    _.get(sorting, 'sortDir') !== 'asc';
  return (
    hasDefaultSort &&
    CSVersion !== 'v1' &&
    showMoreMode !== Enums.SHOW_MORE_MODE_REPLACE &&
    resolveBoolean(shouldAutoPoll) &&
    experienceVersion >= 70
  );
}

export default {
  getLayoutComponent,
  allowAutoPolling,
};
